import config from '../core/config';

function getCookie(name) {
    var nameequal = name + "=";
    var cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
        var current = cookies[i];

        while (current.charAt(0) == ' ') {
            current = current.substring(1, current.length);
        }

        if (current.indexOf(nameequal) == 0) {
            return current.substring(nameequal.length, current.length);
        }
    }

    return null;
}

function setCookie(name, value, seconds, domain) {
    var expires;

    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + (seconds * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }

    if (document.domain === 'localhost') {
        document.cookie = name + "=" + value + expires + "; path=/";
    } else {
        document.cookie = name + "=" + value + expires + ";domain=" + domain + "; path=/";
    }
}

function remove(name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + document.domain === 'localhost' ? '' : '; domain=' + config.dominio;
}

module.exports = {
    read: function (name) {
        return getCookie(name);
    },
    write: function (name, value) {
        setCookie(name, value, config.expirationcookie, config.dominio);
    }, 
    erase: function (name) {
        remove(name);
    }
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/helpers/cookie.js